<template>
    <div class="property-web-login">
        <header>
            <div class="nav" @click="toHome">
                <img :src="require('@/assets/home/logo.png')" />
                <span>国家烟草质量监督检验中心</span>
                <span> | </span>
                <span class="nav-subtitle">用户登录</span>
            </div>
        </header>
        <body class="login-box">
            <img :src="require('@/assets/login/login-bg.png')" alt="" class="login-img" />

            <transition>
                <reset-pwd v-if="resettingPwd" @back="resettingPwd = false" />
                <div class="login-content" v-else>
                    <a-tabs v-model="activeLoginType" @change="tabChange">
                        <a-tab-pane key="phoneForm" tab="验证码登录">
                            <phone-form ref="phoneForm" />
                        </a-tab-pane>
                        <a-tab-pane key="pwdForm" tab="密码登录">
                            <pwd-form ref="pwdForm" />
                        </a-tab-pane>
                        <!-- <a-tab-pane key="emailForm" tab="邮箱登录">
                            <email-form ref="emailForm" />
                        </a-tab-pane> -->
                    </a-tabs>

                    <div
                        class="forget-pwd"
                        v-show="activeLoginType !== 'phoneForm'"
                        @click="resettingPwd = !resettingPwd"
                    >
                        忘记密码？
                    </div>

                    <button class="submit" @click="login">立即登录</button>
                    <div class="to-register">还没有账号？<a @click="toRegister">立即注册</a></div>
                </div>
            </transition>
        </body>
    </div>
</template>

<script>
import phoneForm from './components/phone-form.vue';
import pwdForm from './components/pwd-form.vue';
import resetPwd from './components/reset-pwd.vue';
import RsaEncryptUtils from '@/common/rsaEncryptUtils';
import { postLogin } from '@/common/api';
import service from '../../utils/service';

export default {
    components: {
        phoneForm,
        pwdForm,
        resetPwd
    },
    data() {
        return {
            activeLoginType: 'phoneForm',
            resettingPwd: false
        };
    },
    methods: {
        tabChange(key) {
            this.activeLoginType = key;
        },

        toHome() {
            this.$router.push({ name: 'home' });
        },

        toRegister() {
            this.$router.push({ name: 'register' });
        },

        async login() {
            //验证码登录目前未实现，先return
            if (this.activeLoginType === 'phoneForm') {
                return;
            }
            const formRefs = this.$refs[this.activeLoginType];
            const pass = await formRefs.validate();
            if (!pass) return;
            const form = formRefs.form;

            //登录之前首先获取公钥
            RsaEncryptUtils.getPublicKey().then(() => {
                const publicKey = sessionStorage.getItem('rsa-public-key');
                const params = {
                    id: form.username,
                    password: RsaEncryptUtils.encode(publicKey, form.password)
                };
                postLogin('/kcauth/login', params, publicKey)
                    .then(res => {
                        if (res.status === 200) {
                            this.$message.success('恭喜你，登录成功');
                            service.get('/core/module/sys/logins/account').then(res => {
                                if (res.status === 200) {
                                    const userInfo = JSON.stringify(res.data);
                                    sessionStorage.setItem('userInfo', userInfo);
                                    this.$store.commit('setUserInfo', res.data);
                                    const params = {
                                        phone: res.data.mobile
                                    };
                                    service
                                        .post('/secure/css/module/users/select/login/userinfo', params)
                                        .then(result => {
                                            if (result.status === 200) {
                                                const detailInfo = JSON.stringify(result.data);
                                                sessionStorage.setItem('detailInfo', detailInfo);
                                            }
                                        });
                                    this.$router.push({ name: 'home' });
                                }
                            });
                        } else {
                            this.$message.error('登录失败');
                        }
                    })
                    .catch(() => {
                        this.$message.error('用户名或者密码不正确');
                    });
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.property-web-login {
    background-color: #f8faff;
    header {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;

        .nav {
            width: 1200px;
            height: 128px;
            display: flex;
            align-items: center;
            cursor: pointer;

            span {
                margin-left: 16px;
                font-size: 32px;
                color: #005299;
                font-weight: 700;

                &:not(:first-child) {
                    margin-left: 12px;
                }
            }

            .nav-subtitle {
                font-weight: normal;
            }
        }
    }
    body.login-box {
        width: 1260px;
        height: 588px;
        margin: 113px auto 0;
        box-shadow: 0 4px 8px 0 rgba(0, 80, 150, 0.19);
        border-radius: 16px;
        display: flex;

        .login-img {
            width: 756px;
        }
        .login-content {
            flex-grow: 1;
            padding: 91px 92px 0;

            ::v-deep {
                .ant-tabs-bar {
                    border-bottom: 0 none;
                }

                .ant-tabs-nav .ant-tabs-tab:not(:last-child) {
                    margin-right: 16px;
                }

                .ant-tabs-tab-active {
                    color: #005096;
                    font-weight: 600;
                }

                .ant-tabs-ink-bar {
                    background-color: #005096;
                }
            }

            ::v-deep {
                .ant-form {
                    color: #999;

                    .ant-form-item:last-child {
                        margin-bottom: 16px;
                    }

                    .ant-input-prefix {
                        font-size: 24px;
                        left: 16px;
                    }

                    .ant-input-affix-wrapper input {
                        height: 48px;
                        font-size: 14px;
                        border: 0 none;
                        background: #f8f8f8;
                        border-radius: 24px;
                        padding-left: 48px;
                        &:focus {
                            box-shadow: none;
                        }
                    }
                }
            }

            .forget-pwd {
                cursor: pointer;
                font-size: 14px;
                color: #3675ad;
                text-align: right;
            }

            .submit {
                width: 100%;
                height: 48px;
                margin: 28px 0 24px 0;
                border: 0 none;
                outline: 0;
                background: #005096;
                box-shadow: 0 5px 10px 0 rgba(0, 80, 150, 0.2);
                border-radius: 24px;
                font-family: PingFangSC-Semibold;
                font-size: 20px;
                color: #ffffff;
                font-weight: 700;
                cursor: pointer;
            }

            .to-register {
                text-align: right;
            }
        }
    }
}
</style>
